/**
 * isThreadKey
 *
 * @description This type guard will assert if the given object key is a ThreadKey.
 */
export function isThreadKey(objectKey) {
  return objectKey['@type'] === 'THREAD_KEY';
}